import {
  RenderAssistantOrganizer
} from "@/components/ui/Icons/IconsCustom";
import { RootState } from "@/redux";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { Switch } from "@fluentui/react-components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AssistantSettings } from "./AssistantSettings";

const AssistantOrgSetting = (props: any) => {
  const { t } = useTranslation();

  const settingStore: ISettingStore = useSelector(
    (state: RootState) => state.settingInfo
  ) as ISettingStore;

  const [statusAssistant, setStatusAssistant] = useState(false);

  const switchOffAssistantSettings = () => {
    // if (props.OnSaveSettings) {
    //   const request: SaveAssistantSettingsRequest = {
    //     HasAssistant: !statusAssistant,
    //   };
    //   props.OnSaveSettings(request).then((response) => {
    //     let alertModel: ShowAlertModel = {
    //       Message: response
    //         ? T("Applied successfully", ContextEnum.OfficeAddin)
    //         : T("Applied unsuccessfully", ContextEnum.OfficeAddin),
    //       AlertType: response ? AlertType.Success : AlertType.Error,
    //       IsMessageTranslated: true,
    //       IsOverlap: true,
    //       Context: ContextEnum.OfficeAddin,
    //       AutoClose: 2000,
    //       IsSetting: true,
    //     };
    //     contextValue.showAlert(alertModel);
    //   });
    // }
    setStatusAssistant(!statusAssistant);
  };

  return (
    <>
      {props.assistantEnable && (
        <div className="assistant-organizer">
          <div className="title-assistant-organizer">
            <div>
              <span className="title">
                <RenderAssistantOrganizer />
                &nbsp;
                {t("Assistant Organizer")}
              </span>
            </div>
            <div className="switch-container">
              <Switch
                checked={statusAssistant}
                onChange={() => {
                  switchOffAssistantSettings();
                }}
              />
            </div>
          </div>
          {statusAssistant ? <AssistantSettings /> : <></>}
          <p className="pdlr-12">
            <strong>{t("Note")}:</strong>{" "}
            {t(
              "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer."
            )}
          </p>
        </div>
      )}
    </>
  );
};

export default AssistantOrgSetting;
